export const SKUConfigKey = 'sku-configs';
export const SKUConfigNameUniqueKey = 'sku-configs-name-unique';
export const MatchingSKUConfigsKey = 'matching-sku-configs';
